import moment from "moment";
import { FormikProps } from "formik";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { FormInitialValues } from "./PanFormReportFilterCardWrapper";

type Props = {
  formikProps: FormikProps<FormInitialValues>;
  onReset: () => void;
};

/**
 * Only the statuses this report can ever show — the pending set the API matches
 * on (`PENDING_STATUSES` in pan-form.service.ts). Picking anything else would
 * always come back empty.
 */
const STATUS_OPTIONS = [
  { label: "Form Fill In Progress", value: "FORM_FILL_IN_PROGRESS" },
  { label: "Verify", value: "VERIFY" },
  { label: "Generate", value: "GENERATE" },
  { label: "Done", value: "DONE" },
];

const TYPE_OPTIONS = [
  { label: "New", value: "NEW" },
  { label: "Correction", value: "CORRECTION" },
];

const PanFormReportFilterCard = ({ formikProps, onReset }: Props) => {
  const { values, setFieldValue, isSubmitting } = formikProps;

  return (
    <div className="flex flex-col gap-3 w-[380px]">
      <div className="flex justify-between">
        <div className="text-primary-main font-medium text-[18px]">Filters</div>
        <button
          type="button"
          className="text-sm text-secondary-main font-medium"
          onClick={onReset}
        >
          Reset Filters
        </button>
      </div>

      <div className="grid grid-cols-1 gap-2">
        <ATMSelect
          name="status"
          value={values.status}
          onChange={(e) => setFieldValue("status", e.target.value)}
          label="Status"
          options={STATUS_OPTIONS}
        />
        <ATMSelect
          name="applicationType"
          value={values.applicationType}
          onChange={(e) => setFieldValue("applicationType", e.target.value)}
          label="Type"
          options={TYPE_OPTIONS}
        />
      </div>

      {/* Applied date range — the API filters `createdAt`, the same date the
          "Applied Date" column shows. */}
      <div className="grid lg:grid-cols-2 xs:grid-cols-1 gap-2">
        <div>
          <ATMDatePicker
            name="startDate"
            value={values.startDate}
            onChange={(newValue) => setFieldValue("startDate", newValue)}
            label="Applied From"
            maxDate={moment().format("yyyy-MM-DD")}
          />
        </div>
        <div>
          <ATMDatePicker
            name="endDate"
            value={values.endDate}
            onChange={(newValue) => setFieldValue("endDate", newValue)}
            label="Applied To"
            minDate={values?.startDate || undefined}
          />
        </div>
      </div>

      <div className="mt-6">
        <ATMLoadingButton
          type="submit"
          isLoading={isSubmitting}
          className="bg-primary-main"
        >
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default PanFormReportFilterCard;
